module.exports = __webpack_public_path__ + "static/media/invite_users.9f4dab35.svg";